import { useState } from 'react';
import apiClient from 'services/_infra/apiClient';

export function useSendRecording() {
  const [uploadProgress, setUploadProgress] = useState(null);

  const sendRecording = async (file, fileName, type, override = false) => {
    const formData = new FormData();
    formData.append('audio', file, `${fileName}.${type}`);
    formData.append('override', override);

    setUploadProgress(0);

    try {
      const response = await apiClient.post('v2/integrations/device/audio', formData, {
        headers: { 'Content-Type': null },
        onUploadProgress: (event) => {
          setUploadProgress(event.progress);
        },
      });

      setUploadProgress(1);
      return response;
    } catch (error) {
      setUploadProgress(null);
      throw error;
    }
  };

  const clearProgress = () => setUploadProgress(null);

  return {
    uploadProgress,
    clearProgress,
    sendRecording,
  };
}
